import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseMutateResource } from '../../utils/types';

type FlightSegmentInput = TrpcInputs['deleteFlightSegment'];
type FlightSegmentOutput = TrpcOutputs['deleteFlightSegment'];

type DeleteFlightSegmentFunction = MutateFunction<FlightSegmentInput, FlightSegmentOutput>;
type DeleteFlightSegment = UseMutateResource<DeleteFlightSegmentFunction>;

export const useDelete = (id: number): DeleteFlightSegment => {
  const { mutateAsync, isLoading, error } = trpc.deleteFlightSegment.useMutation();

  const handleDelete: DeleteFlightSegmentFunction = async () => await mutateAsync({ id });

  return [handleDelete, isLoading, error?.message];
};
